<template>
  <BRow>
    <BCol cols="12">
      <h1>
        افزودن درس جدید به زبان
        {{ languageDetails.persianTitle }}
        ({{ languageDetails.title }})
      </h1>
      <hr class="my-2" />
      <BForm @submit.prevent>
        <BRow>
          <BCol cols="12" md="6">
            <BFormGroup
              label="عنوان درس"
              label-for="title"
              :invalid-feedback="invalidLessonTitle"
              :state="invalidLessonTitleState"
            >
              <BFormInput
                :formatter="titleMaxLength"
                id="title"
                :state="invalidLessonTitleState"
                v-model="newIndependentLessonDetails.title"
                trim
                placeholder="عنوان درس"
              />
            </BFormGroup>
          </BCol>
          <BCol cols="12" md="6">
            <BFormGroup
              label="قیمت جلسه"
              label-for="price"
              :invalid-feedback="invalidLessonPrice"
              :state="invalidLessonPriceState"
            >
              <BFormInput
                :state="invalidLessonPriceState"
                type="number"
                id="price"
                v-model="newIndependentLessonDetails.price"
                trim
                placeholder="قیمت جلسه"
              />
            </BFormGroup>
          </BCol>

          <BCol cols="12">
            <BFormGroup
              :state="invalidLessonDescriptionState"
              label="توضیحات جلسه"
              label-for="desc"
              :invalid-feedback="invalidLessonDescription"
            >
              <b-form-textarea
                :state="invalidLessonDescriptionState"
                id="desc"
                v-model="newIndependentLessonDetails.description"
              ></b-form-textarea>
            </BFormGroup>
          </BCol>
          <BCol cols="12" md="6">
            <BFormGroup label="عکس کاور کلاس" label-for="imageFile">
              <b-form-file
                ref="imageInput"
                id="imageFile"
                @input="convertImageFileToBase64"
                accept="image/*"
              ></b-form-file>
            </BFormGroup>
          </BCol>
          <BCol cols="12" md="6">
            <div class="position-relative" v-if="imagePreview">
              <img
                style="width: 100%; max-height: 10rem; object-fit: contain"
                :src="imagePreview"
              />
              <FeatherIcon
                icon="Trash2Icon"
                size="25"
                class="text-danger position-absolute"
                style="left: 1rem; top: 1rem; cursor: pointer"
                @click="deletePreviewImage"
              />
            </div>
          </BCol>
          <BCol cols="12" md="6">
            <b-form-checkbox
              v-model="newIndependentLessonDetails.justBasic"
              name="check-button"
              switch
            >
              درس در نقشه راه ثبت شود؟
              <b
                >(
                {{ newIndependentLessonDetails.justBasic ? "بله" : "خیر" }})</b
              >
            </b-form-checkbox>
          </BCol>
          <BCol cols="12" md="6">
            <b-form-checkbox
              v-model="newIndependentLessonDetails.isRequired"
              name="check-button"
              switch
            >
              درس اجباری است؟
              <b
                >(
                {{ newIndependentLessonDetails.isRequired ? "بله" : "خیر" }})</b
              >
            </b-form-checkbox>
          </BCol>
        </BRow>
        <BRow>
          <BCol cols="12">
            <div class="w-100 d-flex align-items-center justify-content-end">
              <BButton
                @click="createAnIndependentLesson"
                variant="success"
                :disabled="isCreateLessonButtonDisabled"
              >
                ثبت درس جدید
              </BButton>
            </div>
          </BCol>
        </BRow>
      </BForm>
    </BCol>
  </BRow>
</template>

<script>
export default {
  emits: ["reFetchIndependentLessons"],
  props: {
    languageDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      newIndependentLessonDetails: {
        priority: 0,
        languageId: this.$route.params.id,
        isRequired: true,
        title: null,
        description: null,
        price: null,
        justBasic: true,
        mainImage: null,
      },
      lessonImage: null,
      tempBase64: null,
    };
  },
  methods: {
    convertImageFileToBase64(file) {
      if (file) {
        this.lessonImage = file;
        this.newIndependentLessonDetails.mainImage = file;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async () => {
          this.tempBase64 = reader.result.split(",")[1];
        };
      }
    },
    deletePreviewImage() {
      if (this.newIndependentLessonDetails.mainImage != this.lessonImage) {
        this.tempBase64 = null;
        this.lessonImage = this.newIndependentLessonDetails.mainImage;
      } else {
        this.tempBase64 = `${this.newIndependentLessonDetails.mainImage}Delete`;
        this.lessonImage = null;
      }
      this.$refs.imageInput.reset();
    },
    async createAnIndependentLesson() {
      try {
        let myFormData = new FormData();
        Object.keys(this.newIndependentLessonDetails).forEach((key) => {
          myFormData.append(key, this.newIndependentLessonDetails[key]);
        });
        this.isLoading = true;
        let _this = this;
        let createNewIndependentLesson = new CreateNewIndependentLesson(_this);
        createNewIndependentLesson.setFormData(myFormData);
        await createNewIndependentLesson.sendFormData((res) => {
          if (res.data.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "موفقیت آمیز بود",
                icon: "EditIcon",
                variant: "success",
                text: "کلاس با موفقیت ایجاد شد.",
              },
            });
            _this.newIndependentLessonDetails = {
              priority: 0,
              languageId: +this.$route.params.id,
              isRequired: true,
              title: null,
              description: null,
              price: null,
              justBasic: true,
              mainImage: null,
            };
            URL.revokeObjectURL(_this.lessonImage);
            _this.lessonImage = null;
            _this.$emit("reFetchIndependentLessons");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "لطفا دوباره تلاش کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    titleMaxLength(val) {
      if (val.length > 400) {
        let corrected = val.substring(0, 400);
        return corrected;
      }
      return val;
    },
  },
  computed: {
    invalidLessonTitle() {
      if (
        this.newIndependentLessonDetails.title == null ||
        this.newIndependentLessonDetails.title == ""
      ) {
        return "لطفا عنوان درس را وارد کنید";
      }
    },
    invalidLessonTitleState() {
      if (
        this.newIndependentLessonDetails.title != null &&
        this.newIndependentLessonDetails.title != "" &&
        this.newIndependentLessonDetails.title.length > 0
      ) {
        return true;
      }
      return false;
    },
    invalidLessonPrice() {
      if (
        this.newIndependentLessonDetails.price == null ||
        this.newIndependentLessonDetails.price == ""
      ) {
        return "لطفا قیمت درس را وارد کنید";
      }
    },
    invalidLessonDescription() {
      if (
        this.newIndependentLessonDetails.description == null ||
        this.newIndependentLessonDetails.description == ""
      ) {
        return "لطفا فیلد توضیحات را وارد کنید";
      }
    },
    invalidLessonDescriptionState() {
      if (
        this.newIndependentLessonDetails.description != null &&
        this.newIndependentLessonDetails.description != "" &&
        this.newIndependentLessonDetails.description.length > 0
      ) {
        return true;
      }
      return false;
    },
    invalidLessonPriceState() {
      if (
        this.newIndependentLessonDetails.price != null &&
        this.newIndependentLessonDetails.price != ""
      ) {
        return true;
      }
      return false;
    },
    isCreateLessonButtonDisabled() {
      if (this.invalidLessonPriceState && this.invalidLessonDescriptionState) {
        return false;
      }
      return true;
    },
    imagePreview() {
      if (
        this.lessonImage &&
        this.lessonImage.length > 0 &&
        this.lessonImage !== null &&
        typeof this.lessonImage === "string" &&
        this.lessonImage.includes(".")
      ) {
        return `${this.baseUrl}/${this.lessonImage}`;
      } else if (
        this.lessonImage !== null &&
        this.lessonImage !== null &&
        typeof this.lessonImage === "object"
      ) {
        return URL.createObjectURL(this.lessonImage);
      } else {
        return null;
      }
    },
    baseUrl() {
      return process.env.VUE_APP_BASE_URL;
    },
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BButton,
    BFormFile,
    BFormTextarea,
  },
};
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BButton,
  BFormFile,
  BFormTextarea,
} from "bootstrap-vue";
import { CreateNewIndependentLesson } from "@/libs/Api/IndependentLesson";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
</script>
